import type { Account, RawAccount } from './types';

/**
 * Canonical slug for the Builder plan. Mirrors `BuilderPlanSlug` in
 * customerio/services. Use `isBuilderPlan` rather than comparing the string
 * directly so there's a single source of truth.
 */
export const BUILDER_PLAN_SLUG = 'builder';

export function isBuilderPlan(
  // Partial: a malformed or stale payload can arrive without the slug, and the
  // comparison below is what makes that read as "not Builder".
  account: Partial<Pick<Account, 'plan_slug'>> | Partial<Pick<RawAccount, 'plan_slug'>> | null | undefined,
) {
  return account?.plan_slug === BUILDER_PLAN_SLUG;
}
